import { render } from "./Options.vue?vue&type=template&id=01f284bc&ts=true"
import script from "./Options.vue?vue&type=script&lang=ts"
export * from "./Options.vue?vue&type=script&lang=ts"

import "./Options.vue?vue&type=style&index=0&id=01f284bc&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__